exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".category-header{margin:20px}.list-container{padding-bottom:20px}.nothing-message-container{text-align:center;margin-top:50%}", ""]);

